import React from "react";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";
import { REGIONS } from "./constants/constants";
import { TRANSLATIONS } from "../../constants/translations.constants";
import { getFormattedDateForSyndication } from "../../utils/utils";

const SyndicationHeader = (props) => {
  const { region, businessUnit } = props;
  const regionText = TRANSLATIONS[region]["region"];
  const selectedDate = getFormattedDateForSyndication(businessUnit, props.region, props.selectedDate);
  const businessUnitText = () => {
    if (businessUnit === BUSINESS_UNIT.COCOA) {
      return TRANSLATIONS[region]["Cocoa"];
    }
    return businessUnit;
  };

  const headerImgSrc =
    props.businessUnit === BUSINESS_UNIT.EDIBLE_OILS
      ? props.region === REGIONS.SA
        ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/WeeklyMarketReportHeader.png"
        : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/SyndicationHeader.png"
      : props.businessUnit === BUSINESS_UNIT.ANIMAL_FEED
        ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/FeedHeader.png"
        : props.businessUnit === BUSINESS_UNIT.GRAINS
          ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/Grains_Syndication_Header.png"
          : props.businessUnit === BUSINESS_UNIT.COCOA
            ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/Cocoa_Syndication_Header.png"
            : props.businessUnit === BUSINESS_UNIT.CORN
              ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/Corn_Syndication_Header.png"
              : "";

  return (
    <>
      <table
        align='center'
        style={{
          textAlign: "justify",
          width: "800px",
          backgroundSize: "cover",
          // color: "#cccccc",
          marginBottom: "5px",
        }}
      >
        <tbody>
          <tr>
            <td>
              {props.region === REGIONS.SA ? (
                <img
                  src={props.headerImgSrc || headerImgSrc}
                  width='800'
                  height='183'
                  style={{ width: "800px" }}
                  alt='Syndication Header Img'
                />
              ) : (
                <img
                  src={props.headerImgSrc || headerImgSrc}
                  width='800'
                  height='142'
                  style={{ width: "800px" }}
                  alt='Syndication Header Img'
                />
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          // color: "#cccccc",
          fontWeight: "bold",
          textAlign: "justify",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Open Sans,Helvetica, Arial, sans-serif",
          marginTop: "5px",
          marginBottom: "5px",
        }}
      >
        <tbody>
          <tr>
            <td align='left'>{selectedDate}</td>
            <td align='center' width='33%'>
              {regionText}
            </td>
            <td align='right' width='33%'>
              {businessUnitText()}
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default SyndicationHeader;
